const UIStrategy = require('./ui_strategy');
const trackingUtils = require('od-modules/utils/tracking.utils');

class UIStrategyAvailableAtTheAirportSumo4416 extends UIStrategy {
    constructor(bookingInfo, view, templates, keys, constants = {}) {
        super(bookingInfo, view, templates, keys, constants);
    }

    clickMoreInfo() {
        trackingUtils.trackEventWithCategory('my_area_trip_details', 'seats_offline_no-available', 'seats_offline_no-available_clicks');
        Odigeo.Router.navigate(`manage-my-booking/add-seats-with-airline/${this.bookingInfo.tdToken}`);
    }
    getData() {
        const parentData = super.getData();
        return Odigeo._.merge({}, parentData, {
            parent: {
                base: {
                    status: {
                        box: {
                            classes: this.CONST.informativeStatusBoxClasses,
                        },
                        message: {
                            text: this.keys.addSeatsAtTheAirportTitleSumo4416,
                            moreinfo: this.keys.addSeatsAtTheAirportMoreinfoSumo4416,
                        },
                        icon: {
                            classes: this.CONST.informativeStatusIconClasses,
                        },
                        type: 'seats',
                    },
                },
            },
            child: {
                custom: {
                    clickMoreInfo: this.clickMoreInfo.bind(this),

                },
            },
            bookingInfo: this.bookingInfo,
        });
    }
}

module.exports = UIStrategyAvailableAtTheAirportSumo4416;
